import { createContext } from "react";

import { DistributorsListingFilters } from "../listing/useDistributorsListingFilters";
import { DistributorListingItem } from "./DistributorsListingItem";

interface IDistributorListingContext {
    items: DistributorListingItem[];
    isLoading: boolean;
    totalItems: number;
    addItem(item: DistributorListingItem): void;
    loadData(filters: DistributorsListingFilters): void;
}

export const DistributorListingContext = createContext<IDistributorListingContext>({} as IDistributorListingContext);
